
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About ALMAX DOO
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              ALMAX DOO is a leading software development company specializing in creating innovative applications that enhance digital security and user experience. Based in Sabac, Serbia, we are committed to delivering cutting-edge solutions that protect your online privacy.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our flagship product, ALMAX VPN, represents our dedication to providing users with the highest level of security and privacy protection. We believe that everyone deserves a safe and unrestricted internet experience.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              With a focus on innovation, reliability, and user satisfaction, ALMAX DOO continues to develop applications that make a real difference in people's digital lives. Our team of experienced developers and security experts work tirelessly to ensure our products meet the highest standards.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3 bg-blue-50 px-6 py-3 rounded-full">
                <i className="ri-shield-check-fill text-blue-600 text-2xl"></i>
                <span className="font-semibold text-gray-900">Trusted Security</span>
              </div>
              <div className="flex items-center gap-3 bg-purple-50 px-6 py-3 rounded-full">
                <i className="ri-code-s-slash-line text-purple-600 text-2xl"></i>
                <span className="font-semibold text-gray-900">Expert Development</span>
              </div>
              <div className="flex items-center gap-3 bg-green-50 px-6 py-3 rounded-full">
                <i className="ri-customer-service-2-fill text-green-600 text-2xl"></i>
                <span className="font-semibold text-gray-900">24/7 Support</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/5b6a335034afffeb7e3138b1a0937aa2.jpg"
                alt="ALMAX DOO Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl opacity-20 blur-3xl"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl opacity-20 blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
